import {
  UPDATE_CALCULATIONS,
  UPDATE_CALCULATIONS_FULFILLED,
  UPDATE_CALCULATIONS_REJECTED,
  UPDATE_CALCULATIONS_DISPLAY_MHZ,
  RESTORE_CALCULATIONS
} from '../actions/action-types';
import { DEFAULT_IMPEDANCE_MHZ } from '../constants/globals';
import { mapImpedanceModelingsToChartData, mapImpedanceModelingsToMhzs } from '../lib/simulations/chartData';

const initialState = {
  isCalculating: false,
  errorMessages: [],
  calculated: undefined,
  availableMhzs: [],
  displayMhz: DEFAULT_IMPEDANCE_MHZ 
};

function calculations(state = initialState, action){
  switch(action.type){
    case UPDATE_CALCULATIONS:
      return {
        ...state,
        isCalculating: true,
        calculated: undefined
      };
    case UPDATE_CALCULATIONS_FULFILLED:
      return {
        ...state,
        isCalculating: false,
        calculated: action.payload,
        errorMessages: []
      };
    case UPDATE_CALCULATIONS_REJECTED:
      return {
        ...state,
        isCalculating: false,
        errorMessages: action.payload
      };
    case UPDATE_CALCULATIONS_DISPLAY_MHZ:
      return {
        ...state,
        displayMhz: Number(action.payload)
      };
    case RESTORE_CALCULATIONS:
      return action.payload;
    default:
      return state;
  }
}

export function getPressedThickness(state) {
  return state.calculated ? state.calculated.pressedThickness : undefined;
}

export function getTotalThickness(state) {
  return state.calculated ? state.calculated.thickness : undefined;
}

export function getImpedanceModelings(state) {
  const mhz = getImpedanceDisplayMhz(state);
  return state.calculated
    ? state.calculated.impedanceModelings.map(model => {
      const selectedImpedance = model.impedances
        ? model.impedances.find(impedance => impedance.mhz === mhz)
        : null;

      return {...model, selectedImpedance}
    })
    : undefined;
}

export function getCalculations(state) {
  return state;
}

export function getCharacteristicImpedanceChartData(state) {
  const impedanceModelings = state.calculated && state.calculated.impedanceModelings
  return mapImpedanceModelingsToChartData(impedanceModelings || [], "characteristicImpedance");
}

export function getDifferentialImpedanceChartData(state) {
  const impedanceModelings = state.calculated && state.calculated.impedanceModelings
  return mapImpedanceModelingsToChartData(impedanceModelings || [], "differentialImpedance");
}

export function getPropagationDelayChartData(state) {
  const impedanceModelings = state.calculated && state.calculated.impedanceModelings
  return mapImpedanceModelingsToChartData(impedanceModelings || [], "propagationalDelay");
}

export function getImpedanceDisplayMhz(state) {
  const mhz = state.displayMhz || DEFAULT_IMPEDANCE_MHZ;
  const mhzs = getAvailableImpedanceMhzs(state) || [0];

  return mhzs.indexOf(mhz) >= 0
    ? mhz
    : mhzs[mhzs.length - 1]
}

export function getAvailableImpedanceMhzs(state) {
  const impedanceModelings = state.calculated && state.calculated.impedanceModelings
  return mapImpedanceModelingsToMhzs(impedanceModelings || []);
}

export default calculations;



// WEBPACK FOOTER //
// ./src/reducers/calculations.js